import { accountMemo } from '@heraion/shared';

// EQ-1 — the machine names coined during THIS run of the app, per exercise.
//
// Why it exists (Antenore, 2026-08-13): he created Machine A, then created
// Machine B, and A was gone. Correct by the data model and useless in the
// hand — A had never been logged on, so it existed only as the value in the
// field that B had just overwritten.
//
// ⛔ This is NOT the parallel registry §9.5.2 refuses. A registry is a second
// store of what machines EXIST, and it drifts from the sets that define them.
// This is a recency list of names the athlete just typed into being, it lives
// in memory, it dies with the app, and nothing reads it as truth: an instance
// still only becomes real by being logged. It costs nothing to be wrong —
// re-picking a remembered name rejoins its history anyway, because the
// identity IS the value, not a record.
// #398: an account memo: the names the last account typed are not the next one's.
const minted = accountMemo(() => new Map<string, string[]>());

/** Newest first, so the one just created leads the list. */
export const rememberInstance = (exerciseId: string, value: string): void => {
  const prev = minted().get(exerciseId) ?? [];
  minted().set(exerciseId, [value, ...prev.filter((v) => v !== value)]);
};

export const mintedInstances = (exerciseId: string): string[] =>
  minted().get(exerciseId) ?? [];

/** Tests only — module state would otherwise leak between cases. */
export const resetMintedInstances = (): void => {
  minted().clear();
};
